import Immutable, { List } from 'immutable';
import { IntegrationsFile, RawIntegrationsFile } from './IntegrationsFile';
import { RawIntegrationsFolderMetadata } from './IntegrationsFolderMetadata';

export type SelectedItemId = string;

interface RawIntegrationsSelectedItemInterface {
  id: string;
  itemType: 'file' | 'folder';
  driveId: string;
  item?: RawIntegrationsFile | RawIntegrationsFolderMetadata;
  folderPathIds: string[];
  siteId?: string;
  connectionId: string;
  providerType: string;
}

export type RawIntegrationsSelectedItem = {
  id: string;
  driveId: string;
  folderPathIds: string[];
  siteId?: string;
  connectionId: string;
  providerType: string;
} & (
  | {
      itemType: 'file';
      item?: RawIntegrationsFile;
    }
  | {
      itemType: 'folder';
      item?: RawIntegrationsFolderMetadata;
    }
);

interface IntegrationsSelectedItemInterface {
  id: string;
  itemType: 'file' | 'folder';
  driveId: string;
  item: RawIntegrationsFile | RawIntegrationsFolderMetadata;
  folderPathIds: List<string>;
  siteId?: string;
  connectionId: string;
  providerType: string;
}

const defaultValues: IntegrationsSelectedItemInterface = {
  id: '',
  itemType: 'file',
  driveId: '',
  item: new IntegrationsFile(),
  folderPathIds: List<string>(),
  siteId: undefined,
  connectionId: '',
  providerType: '',
};

export const IntegrationsSelectedItemFactory = Immutable.Record(
  defaultValues,
  'IntegrationsSelectedItem'
);

export class IntegrationsSelectedItem extends IntegrationsSelectedItemFactory {
  static deserialize(
    rawIntegrationsSelectedItem: RawIntegrationsSelectedItemInterface
  ): IntegrationsSelectedItem {
    return new IntegrationsSelectedItem({
      ...rawIntegrationsSelectedItem,
      folderPathIds: List(rawIntegrationsSelectedItem.folderPathIds),
    });
  }

  serialize(): RawIntegrationsSelectedItem {
    return this.toJS();
  }
}
